// Clear error state on input
$(document).on('input change', '.form-input, .form-select', function() {
    const $fieldset = $(this).closest('.form-fieldset');
    $fieldset.removeClass('has-error');
    $fieldset.next('.form-error-message').remove();
});

function validateContactForm($form) {
    let isValid = true;

    // Clear previous errors
    $form.find('.form-fieldset').removeClass('has-error');
    $form.find('.form-error-message').remove();

    $form.find('[required]').each(function() {
        const $input = $(this);
        const $fieldset = $input.closest('.form-fieldset');
        const value = $input.val();

        if (!value || (typeof value === 'string' && value.trim() === '')) {
            isValid = false;
            $fieldset.addClass('has-error');
            $fieldset.after(
                '<div class="form-error-message" style="display: flex;">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>' +
                '<span>Este campo es obligatorio</span></div>'
            );
        }
    });

    return isValid;
}

$("#contact_form, #contact_form_home").submit(function(event) {
    event.preventDefault();

    const $form = $(this);
    const $feedback = $('.js-feedback');

    $feedback.html('').hide();

    if (!validateContactForm($form)) {
        return;
    }

    // Función para enviar el formulario
    function submitForm(token = null) {
        if (token) {
            $form.find('[name="g-recaptcha-response"]').val(token);
        }

        const formData = $form.serialize();

        $.post($form.data('action'), formData, function(response) {
            if(response.success == 0){
                // Mostrar error
                showContactFeedback(response.message, 'error', true, response.errors || {});
            } else {
                // Éxito - Ocultar formulario y mostrar mensaje de éxito
                $form[0].reset();

                var prefix = $form.attr('id') === 'contact_form_home' ? 'home' : 'contact';
                $('.js-' + prefix + '-form-content').fadeOut(400, function() {
                    $('.js-' + prefix + '-form-success').fadeIn(600);
                });
            }
        }).fail(function(xhr) {
            // Manejar errores de validación (422), reCAPTCHA (403) o errores del servidor
            if (xhr.status === 403 && xhr.responseJSON) {
                const response = xhr.responseJSON;
                showContactFeedback(response.error || 'Verificación de seguridad fallida.', 'error', true);
            } else if (xhr.status === 422 && xhr.responseJSON) {
                const response = xhr.responseJSON;
                showContactFeedback(response.message || 'Error de validación', 'error', true, response.errors || {});
            } else {
                showContactFeedback('Se ha producido un error. Por favor, inténtelo más tarde.', 'error', true);
            }
        });
    }

    // Verificar si reCAPTCHA v3 está disponible
    if (typeof grecaptcha !== 'undefined' && typeof recaptchaPublicKey !== 'undefined' && recaptchaPublicKey) {
        try {
            const formType = $form.find('input[name="form_type"]').val() || 'contact_form';
            const action = `contact_${formType}`;

            grecaptcha.ready(function() {
                try {
                    grecaptcha.execute(recaptchaPublicKey, {action: action}).then(function(token) {
                        submitForm(token);
                    }).catch(function(error) {
                        console.warn('reCAPTCHA error:', error);
                        // Si falla reCAPTCHA, enviar sin token
                        submitForm();
                    });
                } catch (e) {
                    console.warn('reCAPTCHA execution error:', e);
                    // Si hay error, enviar sin token
                    submitForm();
                }
            });
        } catch (e) {
            console.warn('reCAPTCHA not available:', e);
            // Si reCAPTCHA no está disponible, enviar sin token
            submitForm();
        }
    } else {
        // reCAPTCHA no está habilitado, enviar directamente
        submitForm();
    }
});

function showContactFeedback(message, type = 'success', expires = false, errors = {}) {
    const feedback = document.querySelector('.js-feedback');
    feedback.innerHTML = '';

    const container = document.createElement('div');
    container.className = `p-4 rounded-lg mb-2 text-sm ${
        type === 'success' ? 'text-green-800' :
        type === 'warning' ? 'text-yellow-800' :
        'text-red-800' // error
    }`;

    if(Object.keys(errors).length > 0){
        const ul = document.createElement('ul');
        ul.className = 'list-disc pl-5';
        Object.values(errors).forEach(errArr => {
            errArr.forEach(err => {
                const li = document.createElement('li');
                li.innerText = err;
                ul.appendChild(li);
            });
        });
        container.appendChild(ul);
    } else {
        container.innerText = message;
    }

    feedback.appendChild(container);
    $(feedback).fadeIn();

    if(expires){
        setTimeout(() => {
            feedback.innerHTML = '';
            $(feedback).fadeOut();
        }, 6000);
    }
}